import React from "react";
import "./ServicesScroller.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRobot,
  faUserTie,
  faFileAlt,
  faGlobe,
  faChartLine,
  faLaptopCode,
  faCheckCircle,
  faComments
} from "@fortawesome/free-solid-svg-icons";

const services = [
  { title: "AI-Powered Learning", icon: faRobot },
  { title: "Naukri Profile Enhancement", icon: faUserTie },
  { title: "Resume Building Support", icon: faFileAlt },
  { title: "LinkedIn Branding", icon: faChartLine },
  { title: "Free Portfolio Website", icon: faGlobe },
  { title: "Weekly Assessments", icon: faCheckCircle },
  { title: "Mock Interviews", icon: faComments }
];

const ServicesScroller = () => {
  const duplicatedServices = [...services, ...services];
  return (
    <section className="scroller-section">
      <h2 className="scroller-heading">Our Services at CodeXLNC</h2>
      <div className="scroller-wrapper">
        <div className="services-scroller">
          {duplicatedServices.map((service, index) => (
            <div className="service-card" key={index}>
              <FontAwesomeIcon icon={service.icon} className="service-icon" />
              <p>{service.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesScroller;